import { render, staticRenderFns } from "./PaginationButtons.vue?vue&type=template&id=525eb1c4&scoped=true&"
import script from "./PaginationButtons.vue?vue&type=script&lang=js&"
export * from "./PaginationButtons.vue?vue&type=script&lang=js&"
import style0 from "./PaginationButtons.vue?vue&type=style&index=0&id=525eb1c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525eb1c4",
  null
  
)

export default component.exports